import React, { useState } from 'react'
import './batch-shelf.scss'
import { layerManage } from '@/utils/layer'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { Expaned, Row } from '@/components/layout/layout'
import classnames from 'classnames'
import MallImg from '@/assets/images/mall.svg'
import CashierImg from '@/assets/images/cashier.svg'
import OutImg from '@/assets/images/saltout.svg'
import WXZ from '@/assets/images/wxz.svg'
import { BaseDialog } from '@/components/dialog/base-dialog'
import PopverConfirm2 from '@/components/popover-confirm/popver-confirm-2'
import Button from '@/components/button/button'
import $msg from '@/utils/message'
import { goodsLibraryStore } from '../../../store/goods-library'
import { errorCallBack } from '@/utils'

interface BatchShelfProps {
    goods_list: number[]
    goods_group_ids: number[]
    goods_secondary_group_ids: number[]
}

const BatchShelf: React.FC<BatchShelfProps> = props => {
    const [onCashier, setOnCashier] = useState<boolean>(true)
    const [onMall, setOnMall] = useState<boolean>(true)

    const batchReq = useRequest(
        () =>
            $post({
                url: '/goods/onekeyeditgoodsonshelfstatus',
                params: {
                    ...props,
                    on_cashier: onCashier,
                    on_mall: onMall,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg(
                    'success',
                    `成功批量${onCashier ? '上架到收银台，' : '从收银台下架，'}${
                        onMall ? '上架到微商城' : '从微商城下架'
                    }`,
                )
                goodsLibraryStore.setUpdateGroupStatus(!goodsLibraryStore.updateGroupStatus)
                layerManage.pop()
            },
            onError: errorCallBack,
        },
    )

    return (
        <BaseDialog isShow onClose={() => layerManage.pop()} title="批量上下架">
            <div className="batch-stock-setting">
                <Row data-width-100p>
                    <Expaned data-column data-center className="container">
                        <div
                            className="title"
                            style={{
                                color: '#14cc9b',
                            }}
                        >
                            收银台
                        </div>
                        <div
                            className={classnames('select-container', {
                                'select-container-active': onCashier,
                            })}
                            onClick={() => setOnCashier(true)}
                        >
                            <div data-margin-right-8>
                                <img className="icon" src={onCashier ? CashierImg : WXZ} alt="" />
                            </div>
                            上架
                        </div>
                        <div
                            className={classnames('select-container', {
                                'select-container-active': !onCashier,
                            })}
                            onClick={() => setOnCashier(false)}
                        >
                            <div data-margin-right-8>
                                <img className="icon" src={!onCashier ? OutImg : WXZ} alt="" />
                            </div>
                            下架
                        </div>
                    </Expaned>
                    <Expaned data-column data-center className="container">
                        <div
                            className="title"
                            style={{
                                color: '#EFA66E',
                            }}
                        >
                            微商城
                        </div>
                        <div
                            className={classnames('select-container', {
                                'select-container-active': onMall,
                            })}
                            onClick={() => setOnMall(true)}
                        >
                            <div data-margin-right-8>
                                <img className="icon" src={onMall ? MallImg : WXZ} alt="" />
                            </div>
                            上架
                        </div>
                        <div
                            className={classnames('select-container', {
                                'select-container-active': !onMall,
                            })}
                            onClick={() => setOnMall(false)}
                        >
                            <div data-margin-right-8>
                                <img className="icon" src={!onMall ? OutImg : WXZ} alt="" />
                            </div>
                            下架
                        </div>
                    </Expaned>
                </Row>
                <PopverConfirm2
                    trigger="click"
                    types="error"
                    placement="topRight"
                    onConfirm={batchReq.run}
                    content={
                        <div data-color-000 data-font-size-14>
                            确定批量
                            <span data-font-weight-600 data-margin-h-4>
                                {onCashier ? '上架到收银台，' : '从收银台下架，'}
                                {onMall ? '上架到微商城' : '从微商城下架'}
                            </span>
                            吗？
                        </div>
                    }
                >
                    <div data-row data-justify-content-flex-end data-margin-v-10 data-margin-right-16>
                        <Button types="default">确认</Button>
                    </div>
                </PopverConfirm2>
            </div>
        </BaseDialog>
    )
}

export default BatchShelf
